import React, { useEffect, useState } from "react";
import OrgChartD3 from "../organisms/orgChart/OrgChart";
import { PropagateLoader } from "react-spinners";
import { GET_USERS_RS } from "../../api/apiAdmin";

const OrgChartTemplate = () => {
	const [orgData, setOrgData] = useState();
	const [loading, setLoading] = useState(true);

		const getUsers = async () => {
			try {
				setLoading(true);
				const usersData = await GET_USERS_RS();
				const sortedData = usersData.sort((a, b) => a.id - b.id);
				setOrgData(sortedData);
			} catch (error) {
				console.error(error);
			} finally {
				setLoading(false);
			}
		};
	
	useEffect(() => {
		getUsers();
	}, []);

	return (
		<div className="w-full">
			{orgData && !loading ? (
				<OrgChartD3 data={orgData} />
			) : (
				<div className="flex justify-center items-center min-h-screen">
					<PropagateLoader color="red" />
				</div>
			)}
		</div>
	);
};

export default OrgChartTemplate;
